import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../environments/environment";
import { BansStorageService } from "../services/bans-storage.service";
import { MobileDeviceService } from "../services/mobile-view-checker.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"]
})
export class SidebarComponent implements OnInit {

  @Input() isExpanded: boolean = true;

  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

  bans: any;
  tooltipText: string = '';
  isNewPaymentExperienceEnabled: boolean = environment.newPaymentExperienceEnableFlag;
  isBillAnalyticsEnabled: boolean = environment.billAnalyticsEnableFlag;
  isPaymentHistoryEnabled: boolean = environment.PaymentHistoryEnableFlag;
  isManagePaymentMethodEnable: boolean = environment.ManagePaymentMethodEnable;
  permissions: String[] = environment.billingProps.permissions;
  apiCallStatus: string = '';
  isMobileView: boolean = false;
  sidebarRoutes = [
    { key: 'invoices', routes: ['/invoices', '/invoices/view-invoice', '/invoices/view-tsa-invoice', '/invoices/dispute', '/invoices/summary', '/invoices/checkout', '/invoices/create-dispute/invoice-info', '/invoices/create-dispute/dispute-summary'], },
    { key: 'payment-history', routes: ['/invoices/payment-history'] },
    { key: 'disputes', routes: ['/invoices/view-my-dispute'] },
    { key: 'usage-records', routes: ['/invoices/usage-records'] },
    { key: 'settings', routes: ['/invoices/setting/autopay', '/invoices/setting/paymentMethods', '/invoices/setting/paperlessBilling'] },
    { key: 'bill-analytics', routes: ['/invoices/bill-analytics'] },
    { key: 'historical-data', routes: ['/invoices/historical-data', '/invoices/historical-data/historical-invoices', '/invoices/historical-data/historical-payments'] },
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private bansService: BansStorageService,
    private MobileDeviceService: MobileDeviceService
  ) { }

  ngOnInit(): void {
    this.bans = [];
    this.bansService.banApiStaus.subscribe((apiStatus: any) => {
      this.apiCallStatus = apiStatus;
    })
    this.MobileDeviceService.isMobileView$.subscribe((isMobile) => {
      this.isMobileView = isMobile;
    });
  }

  isSidebarMenuActive(key: string): boolean {
    const matchedRoutes = this.sidebarRoutes.find(item => item.key === key)?.routes || [];
    let modifiedUrl = this.router.url.replace(/\/[\d-]+$/, '');
    return matchedRoutes.some(route => modifiedUrl == route);
  }

  toggleSidenav() {
    this.isExpanded = !this.isExpanded;
    this.toggleSidebar.emit(this.isExpanded);
  }

  showTooltip(text: string) {
    this.tooltipText = text;
  }

  navigateRoute(route: string) {
    if(this.isMobileView){
      this.isExpanded = false;
    }
    this.router.navigate([route], { relativeTo: this.route });
  }

  hideTooltip() {
    this.tooltipText = '';
  }
}
